export const environment = {
  production: true,
  host: 'https://portal.skideo.com/',
  instantHost: 'https://instant.skideo.com/',
  createHost: 'https://create.skideo.com/',
  sentry_url:
    'https://e807772999b95fe276ed19414dbdc617@o4507882170548224.ingest.de.sentry.io/4507882902782032',
};
